export const whyQuestions = [
  {
    questionNumber: 1,
    questionText: "Would you like to take a break now?",
    choices: {
      A: "I'll bring a blanket.",
      B: "Yes, I could use one.",
      C: "The report is on your desk.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "지금 휴식을 취하시겠습니까?",
      choices: {
        A: "담요를 가져올게요.",
        B: "네, 휴식이 필요해요.",
        C: "보고서가 책상 위에 있습니다.",
      },
    },
    explanation:
      "휴식을 제안하는 질문에는 제안에 대한 직접적인 응답이 필요합니다. B는 '네, 휴식이 필요해요'라고 말하며 휴식 제안에 대해 직접적으로 동의하는 적절한 답변입니다. A는 '담요를 가져올게요'라고 말하는데, 이는 휴식에 관련된 물건을 언급하고 있지만 질문에 대한 직접적인 응답이 아니라 다른 행동을 제안하고 있습니다. C는 '보고서가 책상 위에 있습니다'라고 말하는데, 이는 휴식과 전혀 관련이 없는 정보를 제공하고 있어 질문의 맥락에 맞지 않습니다. 따라서 대화의 흐름과 질문의 의도를 정확히 이해하고 응답하는 B가 유일한 올바른 답변입니다.",
  },
  {
    questionNumber: 2,
    questionText: "Would you like me to send the files now?",
    choices: {
      A: "No, I'll review them first.",
      B: "Please use the metal ones.",
      C: "On the second floor.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "지금 파일들을 보내드릴까요?",
      choices: {
        A: "아니요, 먼저 검토해 보겠습니다.",
        B: "금속 재질의 것을 사용해 주세요.",
        C: "2층에 있습니다.",
      },
    },
    explanation:
      "파일을 보낼지 묻는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. A는 '아니요, 먼저 검토해 보겠습니다'라고 말하며 파일을 보내자는 제안에 대해 직접적으로 대답하고 있습니다. B는 '금속 재질의 것을 사용해 주세요'라고 말하는데, 이는 파일 전송과 관련이 없는 다른 물건에 대한 요청입니다. C는 '2층에 있습니다'라고 말하는데, 이는 위치 정보를 제공하는 것으로 파일 전송 제안과 관련이 없습니다. 따라서 질문의 의도에 직접 응답하는 A가 올바른 답변입니다.",
  },
  {
    questionNumber: 3,
    questionText: "Would you like to sit by the window?",
    choices: {
      A: "That sounds perfect.",
      B: "I washed the windows yesterday.",
      C: "Yes, it's very windy.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "창가에 앉으시겠습니까?",
      choices: {
        A: "그거 좋네요.",
        B: "어제 창문을 닦았어요.",
        C: "네, 매우 바람이 많이 불어요.",
      },
    },
    explanation:
      "창가에 앉을지 묻는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. A는 '그거 좋네요'라고 말하며 창가에 앉자는 제안에 긍정적으로 응답하고 있습니다. B는 '어제 창문을 닦았어요'라고 말하는데, 이는 창문에 관한 정보를 제공하지만 앉을 자리에 대한 제안과는 관련이 없습니다. C는 '네, 매우 바람이 많이 불어요'라고 말하는데, '네'라고 시작하지만 실제로는 창가에 앉는 것과 관련 없는 날씨 상태를 언급하고 있습니다. 따라서 제안에 직접 응답하는 A가 올바른 답변입니다.",
  },
  {
    questionNumber: 4,
    questionText: "Would you like us to call a taxi for you?",
    choices: {
      A: "It's on the third shelf.",
      B: "No thanks, I'll drive.",
      C: "I went to the supermarket.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "택시를 불러드릴까요?",
      choices: {
        A: "3번째 선반에 있습니다.",
        B: "괜찮습니다, 제가 운전할게요.",
        C: "슈퍼마켓에 다녀왔어요.",
      },
    },
    explanation:
      "택시를 불러줄지 묻는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. B는 '괜찮습니다, 제가 운전할게요'라고 말하며 택시 제안에 대해 정중하게 거절하고 대안을 제시하고 있습니다. A는 '3번째 선반에 있습니다'라고 말하는데, 이는 위치 정보를 제공하는 것으로 택시 호출과 전혀 관련이 없습니다. C는 '슈퍼마켓에 다녀왔어요'라고 말하는데, 이는 과거 행동에 대한 정보를 제공하는 것으로 택시 호출 제안과 관련이 없습니다. 따라서 제안에 직접 응답하는 B가 올바른 답변입니다.",
  },
  {
    questionNumber: 5,
    questionText: "Would you like to join the training session at noon?",
    choices: {
      A: "Yes, it fits my schedule.",
      B: "The projector is broken.",
      C: "No, I printed the agenda.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "정오에 있는 교육 세션에 참여하시겠습니까?",
      choices: {
        A: "네, 제 일정에 맞습니다.",
        B: "프로젝터가 고장났습니다.",
        C: "아니요, 일정표를 인쇄했습니다.",
      },
    },
    explanation:
      "교육 세션 참여 제안에는 그 제안에 대한 직접적인 응답이 필요합니다. A는 '네, 제 일정에 맞습니다'라고 말하며 교육 세션 참여 제안에 직접적으로 동의하고 있습니다. B는 '프로젝터가 고장났습니다'라고 말하는데, 이는 교육 세션과 관련될 수 있는 장비에 대한 정보이지만 참여 여부에 대한 응답이 아닙니다. C는 '아니요, 일정표를 인쇄했습니다'라고 말하는데, '아니요'로 시작하지만 뒤에 이어지는 내용이 참여 거절의 이유와 논리적으로 연결되지 않습니다. 따라서 제안에 직접 응답하는 A가 올바른 답변입니다.",
  },
  {
    questionNumber: 6,
    questionText: "Would you like some coffee before the meeting?",
    choices: {
      A: "The room is too small.",
      B: "I'd love some, thanks.",
      C: "I used the coffee machine.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "회의 전에 커피 좀 드시겠습니까?",
      choices: {
        A: "방이 너무 작습니다.",
        B: "좋아요, 감사합니다.",
        C: "커피 머신을 사용했습니다.",
      },
    },
    explanation:
      "커피를 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. B는 '좋아요, 감사합니다'라고 말하며 커피 제안에 감사하며 수락하고 있습니다. A는 '방이 너무 작습니다'라고 말하는데, 이는 회의실에 대한 의견으로 커피 제안과 관련이 없습니다. C는 '커피 머신을 사용했습니다'라고 말하는데, 이는 과거에 한 행동에 대한 정보를 제공하는 것으로 현재의 커피 제안에 대한 응답이 아닙니다. 따라서 제안에 직접 응답하는 B가 올바른 답변입니다.",
  },
  {
    questionNumber: 7,
    questionText: "Would you like to handle the presentation?",
    choices: {
      A: "Sure, I've already prepared some slides.",
      B: "The projector is under repair.",
      C: "It's a bit too dark in here.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "발표를 맡아보시겠습니까?",
      choices: {
        A: "물론이죠, 이미 슬라이드를 준비해 두었습니다.",
        B: "프로젝터가 수리 중입니다.",
        C: "여기는 조금 너무 어둡습니다.",
      },
    },
    explanation:
      "발표를 맡아볼지 묻는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. A는 '물론이죠, 이미 슬라이드를 준비해 두었습니다'라고 말하며 발표를 맡겠다는 의사를 분명히 표현하고 있습니다. B는 '프로젝터가 수리 중입니다'라고 말하는데, 이는 발표와 관련된 장비에 대한 정보이지만 발표를 맡을지에 대한 직접적인 응답이 아닙니다. C는 '여기는 조금 너무 어둡습니다'라고 말하는데, 이는 발표 환경에 대한 의견으로 발표를 맡을지에 대한 응답이 아닙니다. 따라서 제안에 직접 응답하는 A가 올바른 답변입니다.",
  },
  {
    questionNumber: 8,
    questionText: "Would you like to reschedule the appointment?",
    choices: {
      A: "No, the current time is fine.",
      B: "He's the new receptionist.",
      C: "The meeting room was large.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "약속 일정을 변경하시겠습니까?",
      choices: {
        A: "아니요, 현재 시간이 괜찮습니다.",
        B: "그는 새로운 접수원입니다.",
        C: "회의실이 컸습니다.",
      },
    },
    explanation:
      "약속 일정 변경을 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. A는 '아니요, 현재 시간이 괜찮습니다'라고 말하며 일정 변경 제안에 대해 직접적으로 거절하고 있습니다. B는 '그는 새로운 접수원입니다'라고 말하는데, 이는 특정 인물에 대한 정보를 제공하는 것으로 일정 변경과 관련이 없습니다. C는 '회의실이 컸습니다'라고 말하는데, 이는 과거 회의실에 대한 정보를 제공하는 것으로 일정 변경 제안과 관련이 없습니다. 따라서 제안에 직접 응답하는 A가 올바른 답변입니다.",
  },
  {
    questionNumber: 9,
    questionText: "Would you like to review the draft before I send it?",
    choices: {
      A: "Let me check it quickly.",
      B: "I printed the first draft.",
      C: "The mail room closes at five.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "제가 보내기 전에 초안을 검토해 보시겠습니까?",
      choices: {
        A: "빠르게 확인해 볼게요.",
        B: "첫 번째 초안을 인쇄했습니다.",
        C: "우편실은 5시에 닫습니다.",
      },
    },
    explanation:
      "초안 검토를 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. A는 '빠르게 확인해 볼게요'라고 말하며 초안 검토 제안에 동의하고 있습니다. B는 '첫 번째 초안을 인쇄했습니다'라고 말하는데, 이는 과거에 한 행동에 대한 정보를 제공하는 것으로 현재의 검토 제안에 대한 응답이 아닙니다. C는 '우편실은 5시에 닫습니다'라고 말하는데, 이는 우편실 운영 시간에 대한 정보를 제공하는 것으로 초안 검토와 관련이 없습니다. 따라서 제안에 직접 응답하는 A가 올바른 답변입니다.",
  },
  {
    questionNumber: 10,
    questionText: "Would you like to stay a bit longer?",
    choices: {
      A: "Yes, I'm not in a hurry.",
      B: "I already locked the door.",
      C: "It's very long.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "조금 더 머무르시겠습니까?",
      choices: {
        A: "네, 서두를 필요가 없어요.",
        B: "이미 문을 잠갔어요.",
        C: "매우 길어요.",
      },
    },
    explanation:
      "더 머물지 묻는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. A는 '네, 서두를 필요가 없어요'라고 말하며 더 머물자는 제안에 동의하고 있습니다. B는 '이미 문을 잠갔어요'라고 말하는데, 이는 과거에 한 행동에 대한 정보를 제공하는 것으로 더 머물지에 대한 직접적인 응답이 아닙니다. C는 '매우 길어요'라고 말하는데, 이는 무언가의 길이나 시간에 대한 의견으로 더 머물지에 대한 명확한 응답이 아닙니다. 따라서 제안에 직접 응답하는 A가 올바른 답변입니다.",
  },
  {
    questionNumber: 11,
    questionText: "Would you like me to proofread your report?",
    choices: {
      A: "The printer ran out of ink.",
      B: "It's about quarterly earnings.",
      C: "No, I've already checked it.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "제가 당신의 보고서를 교정해 드릴까요?",
      choices: {
        A: "프린터의 잉크가 떨어졌어요.",
        B: "분기별 수익에 관한 것입니다.",
        C: "아니요, 이미 확인했습니다.",
      },
    },
    explanation:
      "보고서 교정을 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. C는 '아니요, 이미 확인했습니다'라고 말하며 교정 제안에 대해 직접적으로 거절하고 있습니다. A는 '프린터의 잉크가 떨어졌어요'라고 말하는데, 이는 프린터 상태에 대한 정보를 제공하는 것으로 교정 제안과 관련이 없습니다. B는 '분기별 수익에 관한 것입니다'라고 말하는데, 이는 보고서 내용에 대한 정보를 제공하는 것으로 교정 제안에 대한 직접적인 응답이 아닙니다. 따라서 제안에 직접 응답하는 C가 올바른 답변입니다.",
  },
  {
    questionNumber: 12,
    questionText: "Would you like to order dessert now?",
    choices: {
      A: "I'd rather wait a bit.",
      B: "I usually eat at home.",
      C: "The server is new.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "지금 디저트를 주문하시겠습니까?",
      choices: {
        A: "조금 더 기다리고 싶어요.",
        B: "보통 집에서 먹어요.",
        C: "서버가 새로운 사람이에요.",
      },
    },
    explanation:
      "디저트 주문을 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. A는 '조금 더 기다리고 싶어요'라고 말하며 지금 디저트를 주문하자는 제안에 대해 직접적으로 응답하고 있습니다. B는 '보통 집에서 먹어요'라고 말하는데, 이는 일반적인 식사 습관에 대한 정보를 제공하는 것으로 현재 디저트 주문 제안에 대한 직접적인 응답이 아닙니다. C는 '서버가 새로운 사람이에요'라고 말하는데, 이는 서버에 대한 정보를 제공하는 것으로 디저트 주문과 관련이 없습니다. 따라서 제안에 직접 응답하는 A가 올바른 답변입니다.",
  },
  {
    questionNumber: 13,
    questionText: "Would you like a tour of the facility?",
    choices: {
      A: "The floor needs cleaning.",
      B: "Yes, that would be great.",
      C: "I locked the front gate.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "시설 투어를 원하십니까?",
      choices: {
        A: "바닥을 청소해야 합니다.",
        B: "네, 그거 좋겠네요.",
        C: "정문을 잠갔습니다.",
      },
    },
    explanation:
      "시설 투어를 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. B는 '네, 그거 좋겠네요'라고 말하며 투어 제안에 동의하고 있습니다. A는 '바닥을 청소해야 합니다'라고 말하는데, 이는 시설 상태에 대한 정보를 제공하는 것으로 투어 제안에 대한 응답이 아닙니다. C는 '정문을 잠갔습니다'라고 말하는데, 이는 과거에 한 행동에 대한 정보를 제공하는 것으로 투어 제안과 관련이 없습니다. 따라서 제안에 직접 응답하는 B가 올바른 답변입니다.",
  },
  {
    questionNumber: 14,
    questionText: "Would you like to pay by credit card?",
    choices: {
      A: "No, she made the reservation.",
      B: "I don't have her contact number.",
      C: "I'll use my company card.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "신용카드로 결제하시겠습니까?",
      choices: {
        A: "아니요, 그녀가 예약했습니다.",
        B: "그녀의 연락처가 없습니다.",
        C: "회사 카드를 사용하겠습니다.",
      },
    },
    explanation:
      "신용카드 결제를 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. C는 '회사 카드를 사용하겠습니다'라고 말하며 카드 결제 제안에 동의하고 있습니다. A는 '아니요, 그녀가 예약했습니다'라고 말하는데, 이는 예약에 대한 정보를 제공하는 것으로 결제 방법과 관련이 없습니다. B는 '그녀의 연락처가 없습니다'라고 말하는데, 이는 연락처에 대한 정보를 제공하는 것으로 결제 방법과 관련이 없습니다. 따라서 제안에 직접 응답하는 C가 올바른 답변입니다.",
  },
  {
    questionNumber: 15,
    questionText: "Would you like some help with that?",
    choices: {
      A: "I haven't met him before.",
      B: "It's under the table.",
      C: "Yes, I'd appreciate it.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "그것에 대해 도움이 필요하십니까?",
      choices: {
        A: "그를 전에 만난 적이 없습니다.",
        B: "테이블 아래에 있습니다.",
        C: "네, 감사하겠습니다.",
      },
    },
    explanation:
      "도움을 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. C는 '네, 감사하겠습니다'라고 말하며 도움 제안에 동의하고 있습니다. A는 '그를 전에 만난 적이 없습니다'라고 말하는데, 이는 특정 인물에 대한 정보를 제공하는 것으로 도움 제안과 관련이 없습니다. B는 '테이블 아래에 있습니다'라고 말하는데, 이는 물건의 위치에 대한 정보를 제공하는 것으로 도움 제안에 대한 응답이 아닙니다. 따라서 제안에 직접 응답하는 C가 올바른 답변입니다.",
  },
  {
    questionNumber: 16,
    questionText: "Would you like to look at the draft together?",
    choices: {
      A: "It's in the top drawer.",
      B: "I left early yesterday.",
      C: "We can do that now.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "초안을 함께 검토해 보시겠습니까?",
      choices: {
        A: "상단 서랍에 있습니다.",
        B: "어제 일찍 떠났습니다.",
        C: "지금 그렇게 할 수 있습니다.",
      },
    },
    explanation:
      "초안을 함께 검토하자는 제안에는 그 제안에 대한 직접적인 응답이 필요합니다. C는 '지금 그렇게 할 수 있습니다'라고 말하며 함께 검토하자는 제안에 동의하고 있습니다. A는 '상단 서랍에 있습니다'라고 말하는데, 이는 초안의 위치에 대한 정보를 제공하는 것으로 함께 검토하자는 제안에 대한 응답이 아닙니다. B는 '어제 일찍 떠났습니다'라고 말하는데, 이는 과거 행동에 대한 정보를 제공하는 것으로 현재의 제안과 관련이 없습니다. 따라서 제안에 직접 응답하는 C가 올바른 답변입니다.",
  },
  {
    questionNumber: 17,
    questionText: "Would you like to change the seating arrangement?",
    choices: {
      A: "That might be better.",
      B: "The chairs are red.",
      C: "No, I haven't seen the memo.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "좌석 배치를 변경하시겠습니까?",
      choices: {
        A: "그게 더 나을 것 같습니다.",
        B: "의자는 빨간색입니다.",
        C: "아니요, 메모를 보지 못했습니다.",
      },
    },
    explanation:
      "좌석 배치 변경을 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. A는 '그게 더 나을 것 같습니다'라고 말하며 좌석 배치 변경 제안에 동의하고 있습니다. B는 '의자는 빨간색입니다'라고 말하는데, 이는 의자의 색상에 대한 정보를 제공하는 것으로 좌석 배치 변경과 관련이 없습니다. C는 '아니요, 메모를 보지 못했습니다'라고 말하는데, 이는 메모에 대한 정보를 제공하는 것으로 좌석 배치 변경 제안에 대한 직접적인 응답이 아닙니다. 따라서 제안에 직접 응답하는 A가 올바른 답변입니다.",
  },
  {
    questionNumber: 18,
    questionText: "Would you like us to email the invoice?",
    choices: {
      A: "It's due next Friday.",
      B: "I prefer a printed copy.",
      C: "I forgot my password.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "청구서를 이메일로 보내드릴까요?",
      choices: {
        A: "다음 금요일이 마감입니다.",
        B: "인쇄된 사본을 선호합니다.",
        C: "비밀번호를 잊어버렸습니다.",
      },
    },
    explanation:
      "청구서를 이메일로 보내자는 제안에는 그 제안에 대한 직접적인 응답이 필요합니다. B는 '인쇄된 사본을 선호합니다'라고 말하며 이메일 대신 다른 방식을 선호한다고 직접적으로 응답하고 있습니다. A는 '다음 금요일이 마감입니다'라고 말하는데, 이는 마감일에 대한 정보를 제공하는 것으로 이메일 발송 제안에 대한 응답이 아닙니다. C는 '비밀번호를 잊어버렸습니다'라고 말하는데, 이는 비밀번호에 대한 정보를 제공하는 것으로 이메일 발송 제안과 직접적인 관련이 없습니다. 따라서 제안에 직접 응답하는 B가 올바른 답변입니다.",
  },
  {
    questionNumber: 19,
    questionText: "Would you like to move the meeting to 3 p.m.?",
    choices: {
      A: "It's a three-hour session.",
      B: "Sure, that works for me.",
      C: "The projector is on the shelf.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "회의를 오후 3시로 옮기시겠습니까?",
      choices: {
        A: "3시간 세션입니다.",
        B: "네, 그 시간이 괜찮습니다.",
        C: "프로젝터는 선반 위에 있습니다.",
      },
    },
    explanation:
      "회의 시간 변경을 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. B는 '네, 그 시간이 괜찮습니다'라고 말하며 회의 시간 변경 제안에 동의하고 있습니다. A는 '3시간 세션입니다'라고 말하는데, 이는 회의 길이에 대한 정보를 제공하는 것으로 시간 변경 제안에 대한 직접적인 응답이 아닙니다. C는 '프로젝터는 선반 위에 있습니다'라고 말하는데, 이는 장비 위치에 대한 정보를 제공하는 것으로 회의 시간 변경과 관련이 없습니다. 따라서 제안에 직접 응답하는 B가 올바른 답변입니다.",
  },
  {
    questionNumber: 20,
    questionText: "Would you like to extend your stay by one night?",
    choices: {
      A: "Yes, I need more time.",
      B: "The window won't open.",
      C: "I'm staying in Room 308.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "체류를 하루 더 연장하시겠습니까?",
      choices: {
        A: "네, 시간이 더 필요합니다.",
        B: "창문이 열리지 않습니다.",
        C: "저는 308호에 머물고 있습니다.",
      },
    },
    explanation:
      "체류 연장을 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. A는 '네, 시간이 더 필요합니다'라고 말하며 체류 연장 제안에 동의하고 있습니다. B는 '창문이 열리지 않습니다'라고 말하는데, 이는 객실 상태에 대한 정보를 제공하는 것으로 체류 연장과 관련이 없습니다. C는 '저는 308호에 머물고 있습니다'라고 말하는데, 이는 객실 번호에 대한 정보를 제공하는 것으로 체류 연장 제안에 대한 응답이 아닙니다. 따라서 제안에 직접 응답하는 A가 올바른 답변입니다.",
  },
  {
    questionNumber: 21,
    questionText: "Would you like to meet after lunch?",
    choices: {
      A: "I brought my own lunch.",
      B: "Yes, I'm free around 2.",
      C: "The cafeteria closes at one.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "점심 식사 후에 만나실래요?",
      choices: {
        A: "제 점심을 가져왔습니다.",
        B: "네, 2시쯤에 시간이 있습니다.",
        C: "구내식당은 1시에 문을 닫습니다.",
      },
    },
    explanation:
      "점심 식사 후 만남을 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. B는 '네, 2시쯤에 시간이 있습니다'라고 말하며 만남 제안에 동의하고 있습니다. A는 '제 점심을 가져왔습니다'라고 말하는데, 이는 점심에 대한 정보를 제공하는 것으로 만남 제안에 대한 직접적인 응답이 아닙니다. C는 '구내식당은 1시에 문을 닫습니다'라고 말하는데, 이는 구내식당 운영 시간에 대한 정보를 제공하는 것으로 만남 제안과 직접적인 관련이 없습니다. 따라서 제안에 직접 응답하는 B가 올바른 답변입니다.",
  },
  {
    questionNumber: 22,
    questionText: "Would you like me to reschedule your appointment?",
    choices: {
      A: "Yes, I won't be available then.",
      B: "It's at the reception desk.",
      C: "I already submitted the form.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "약속을 다시 잡아드릴까요?",
      choices: {
        A: "네, 그때는 시간이 안 됩니다.",
        B: "접수처에 있습니다.",
        C: "이미 양식을 제출했습니다.",
      },
    },
    explanation:
      "약속 일정 변경을 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. A는 '네, 그때는 시간이 안 됩니다'라고 말하며 일정 변경 제안에 동의하고 있습니다. B는 '접수처에 있습니다'라고 말하는데, 이는 위치에 대한 정보를 제공하는 것으로 일정 변경 제안과 관련이 없습니다. C는 '이미 양식을 제출했습니다'라고 말하는데, 이는 양식 제출에 대한 정보를 제공하는 것으로 약속 일정 변경과 직접적인 관련이 없습니다. 따라서 제안에 직접 응답하는 A가 올바른 답변입니다.",
  },
  {
    questionNumber: 23,
    questionText: "Would you like to take the elevator or the stairs?",
    choices: {
      A: "The lights are off in the hallway.",
      B: "I'd rather take the stairs.",
      C: "I reserved the conference room.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "엘리베이터를 타실래요, 아니면 계단을 이용하실래요?",
      choices: {
        A: "복도의 불이 꺼져 있습니다.",
        B: "계단을 이용하는 게 좋겠습니다.",
        C: "회의실을 예약했습니다.",
      },
    },
    explanation:
      "이동 방법을 선택하라는 질문에는 그 선택에 대한 직접적인 응답이 필요합니다. B는 '계단을 이용하는 게 좋겠습니다'라고 말하며 두 가지 선택지 중 하나를 명확히 선택하고 있습니다. A는 '복도의 불이 꺼져 있습니다'라고 말하는데, 이는 복도 상태에 대한 정보를 제공하는 것으로 이동 방법 선택과 직접적인 관련이 없습니다. C는 '회의실을 예약했습니다'라고 말하는데, 이는 회의실 예약에 대한 정보를 제공하는 것으로 이동 방법 선택과 관련이 없습니다. 따라서 선택에 직접 응답하는 B가 올바른 답변입니다.",
  },
  {
    questionNumber: 24,
    questionText: "Would you like to listen to the voicemail now?",
    choices: {
      A: "No, I'll check it later.",
      B: "The volume is too low.",
      C: "He didn't leave his name.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "지금 음성 메시지를 들으시겠습니까?",
      choices: {
        A: "아니요, 나중에 확인하겠습니다.",
        B: "볼륨이 너무 낮습니다.",
        C: "그는 이름을 남기지 않았습니다.",
      },
    },
    explanation:
      "음성 메시지를 지금 들을지 묻는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. A는 '아니요, 나중에 확인하겠습니다'라고 말하며 제안에 대해 명확히 거절하고 있습니다. B는 '볼륨이 너무 낮습니다'라고 말하는데, 이는 볼륨 상태에 대한 정보를 제공하는 것으로 지금 들을지에 대한 직접적인 응답이 아닙니다. C는 '그는 이름을 남기지 않았습니다'라고 말하는데, 이는 메시지 내용에 대한 정보를 제공하는 것으로 지금 들을지에 대한 응답이 아닙니다. 따라서 제안에 직접 응답하는 A가 올바른 답변입니다.",
  },
  {
    questionNumber: 25,
    questionText: "Would you like me to arrange a car for you?",
    choices: {
      A: "It's in the garage.",
      B: "That would be helpful.",
      C: "I took the elevator.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "차량을 준비해 드릴까요?",
      choices: {
        A: "차고에 있습니다.",
        B: "그렇게 해주시면 도움이 되겠습니다.",
        C: "엘리베이터를 탔습니다.",
      },
    },
    explanation:
      "차량 준비를 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. B는 '그렇게 해주시면 도움이 되겠습니다'라고 말하며 차량 준비 제안에 동의하고 있습니다. A는 '차고에 있습니다'라고 말하는데, 이는 위치에 대한 정보를 제공하는 것으로 차량 준비 제안에 대한 직접적인 응답이 아닙니다. C는 '엘리베이터를 탔습니다'라고 말하는데, 이는 이전 행동에 대한 정보를 제공하는 것으로 차량 준비와 관련이 없습니다. 따라서 제안에 직접 응답하는 B가 올바른 답변입니다.",
  },
  {
    questionNumber: 26,
    questionText: "Would you like to register for the workshop?",
    choices: {
      A: "No, I've already attended.",
      B: "It starts next week.",
      C: "The venue has changed.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "워크숍에 등록하시겠습니까?",
      choices: {
        A: "아니요, 이미 참석했습니다.",
        B: "다음 주에 시작합니다.",
        C: "장소가 변경되었습니다.",
      },
    },
    explanation:
      "워크숍 등록을 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. A는 '아니요, 이미 참석했습니다'라고 말하며 등록 제안에 대해 명확히 거절하고 있습니다. B는 '다음 주에 시작합니다'라고 말하는데, 이는 워크숍 일정에 대한 정보를 제공하는 것으로 등록 제안에 대한 직접적인 응답이 아닙니다. C는 '장소가 변경되었습니다'라고 말하는데, 이는 워크숍 장소에 대한 정보를 제공하는 것으로 등록 제안과 직접적인 관련이 없습니다. 따라서 제안에 직접 응답하는 A가 올바른 답변입니다.",
  },
  {
    questionNumber: 27,
    questionText: "Would you like to book the larger conference room?",
    choices: {
      A: "I think the smaller one will do.",
      B: "It's on the second floor.",
      C: "I forgot the login credentials.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "더 큰 회의실을 예약하시겠습니까?",
      choices: {
        A: "작은 회의실로도 충분할 것 같습니다.",
        B: "2층에 있습니다.",
        C: "로그인 정보를 잊어버렸습니다.",
      },
    },
    explanation:
      "더 큰 회의실 예약을 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. A는 '작은 회의실로도 충분할 것 같습니다'라고 말하며 더 큰 회의실 예약 제안에 대해 간접적으로 거절하고 있습니다. B는 '2층에 있습니다'라고 말하는데, 이는 위치에 대한 정보를 제공하는 것으로 예약 제안에 대한 직접적인 응답이 아닙니다. C는 '로그인 정보를 잊어버렸습니다'라고 말하는데, 이는 로그인 문제에 대한 정보를 제공하는 것으로 회의실 예약과 직접적인 관련이 없습니다. 따라서 제안에 직접 응답하는 A가 올바른 답변입니다.",
  },
  {
    questionNumber: 28,
    questionText: "Would you like to receive a printed copy?",
    choices: {
      A: "He already signed the document.",
      B: "Sure, that would be better.",
      C: "The printer was jammed.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "인쇄된 사본을 받으시겠습니까?",
      choices: {
        A: "그는 이미 문서에 서명했습니다.",
        B: "네, 그게 더 좋겠습니다.",
        C: "프린터가 걸렸습니다.",
      },
    },
    explanation:
      "인쇄된 사본 수령을 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. B는 '네, 그게 더 좋겠습니다'라고 말하며 인쇄된 사본 수령 제안에 동의하고 있습니다. A는 '그는 이미 문서에 서명했습니다'라고 말하는데, 이는 문서 상태에 대한 정보를 제공하는 것으로 사본 수령 제안에 대한 직접적인 응답이 아닙니다. C는 '프린터가 걸렸습니다'라고 말하는데, 이는 프린터 상태에 대한 정보를 제공하는 것으로 사본 수령 제안과 직접적인 관련이 없습니다. 따라서 제안에 직접 응답하는 B가 올바른 답변입니다.",
  },
  {
    questionNumber: 29,
    questionText: "Would you like to stop by the bank on our way?",
    choices: {
      A: "No, I already withdrew cash.",
      B: "The traffic was heavy.",
      C: "It's across the street.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "가는 길에 은행에 들르시겠습니까?",
      choices: {
        A: "아니요, 이미 현금을 인출했습니다.",
        B: "교통이 혼잡했습니다.",
        C: "길 건너편에 있습니다.",
      },
    },
    explanation:
      "은행 방문을 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. A는 '아니요, 이미 현금을 인출했습니다'라고 말하며 은행 방문 제안에 대해 명확히 거절하고 있습니다. B는 '교통이 혼잡했습니다'라고 말하는데, 이는 교통 상황에 대한 정보를 제공하는 것으로 은행 방문 제안에 대한 직접적인 응답이 아닙니다. C는 '길 건너편에 있습니다'라고 말하는데, 이는 은행 위치에 대한 정보를 제공하는 것으로 방문 제안에 대한 응답이 아닙니다. 따라서 제안에 직접 응답하는 A가 올바른 답변입니다.",
  },
  {
    questionNumber: 30,
    questionText: "Would you like to try a different color?",
    choices: {
      A: "The size is medium.",
      B: "Yes, maybe something darker.",
      C: "It's out of stock.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "다른 색상을 시도해 보시겠습니까?",
      choices: {
        A: "사이즈는 중간입니다.",
        B: "네, 아마도 더 어두운 색상으로요.",
        C: "재고가 없습니다.",
      },
    },
    explanation:
      "다른 색상 시도를 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. B는 '네, 아마도 더 어두운 색상으로요'라고 말하며 다른 색상 시도 제안에 동의하고 있습니다. A는 '사이즈는 중간입니다'라고 말하는데, 이는 사이즈에 대한 정보를 제공하는 것으로 색상 변경 제안에 대한 직접적인 응답이 아닙니다. C는 '재고가 없습니다'라고 말하는데, 이는 재고 상태에 대한 정보를 제공하는 것으로 색상 시도 제안과 직접적인 관련이 없습니다. 따라서 제안에 직접 응답하는 B가 올바른 답변입니다.",
  },
  {
    questionNumber: 31,
    questionText: "Would you like some coffee?",
    choices: {
      A: "I just made a fresh pot.",
      B: "I usually take the bus.",
      C: "Yes, that sounds great.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "커피 드시겠습니까?",
      choices: {
        A: "방금 새로 커피를 내렸습니다.",
        B: "저는 보통 버스를 타요.",
        C: "네, 좋습니다.",
      },
    },
    explanation:
      "커피를 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. C는 '네, 좋습니다'라고 말하며 커피 제안에 직접 응답하고 있습니다. A는 '방금 새로 커피를 내렸습니다'라고 말하는데, 이는 커피 상태에 대한 정보를 제공하는 것으로 커피 제안에 대한 직접적인 응답이 아닙니다(논리 비약형). B는 '저는 보통 버스를 타요'라고 말하는데, 이는 커피 제안과 전혀 관련이 없는 주제입니다(주제 이탈형). 따라서 제안에 직접 응답하는 C가 올바른 답변입니다.",
  },
  {
    questionNumber: 32,
    questionText: "Can I help you carry that box?",
    choices: {
      A: "I already submitted the report.",
      B: "Sure, I'd appreciate it.",
      C: "It's quite heavy.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "그 상자 들어드릴까요?",
      choices: {
        A: "이미 보고서를 제출했습니다.",
        B: "네, 감사합니다.",
        C: "꽤 무겁습니다.",
      },
    },
    explanation:
      "도움을 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. B는 '네, 감사합니다'라고 말하며 도움 제안에 직접 응답하고 있습니다. A는 '이미 보고서를 제출했습니다'라고 말하는데, 이는 상자 운반과 전혀 관련이 없는 주제입니다(주제 이탈형). C는 '꽤 무겁습니다'라고 말하는데, 이는 상자의 상태에 대한 정보를 제공하는 것으로 도움 제안에 대한 직접적인 응답이 아닙니다(논리 비약형). 따라서 제안에 직접 응답하는 B가 올바른 답변입니다.",
  },
  {
    questionNumber: 33,
    questionText: "Shall I book a table for lunch?",
    choices: {
      A: "No, I brought my own lunch.",
      B: "It was raining this morning.",
      C: "The phone's on silent.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "점심 식사를 위해 테이블을 예약할까요?",
      choices: {
        A: "아니요, 도시락을 가져왔습니다.",
        B: "오늘 아침에 비가 왔어요.",
        C: "전화기가 무음 모드입니다.",
      },
    },
    explanation:
      "테이블 예약을 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. A는 '아니요, 도시락을 가져왔습니다'라고 말하며 테이블 예약 제안에 대해 명확히 거절하고 있습니다. B는 '오늘 아침에 비가 왔어요'라고 말하는데, 이는 날씨에 대한 정보를 제공하는 것으로 테이블 예약 제안과 관련이 없습니다. C는 '전화기가 무음 모드입니다'라고 말하는데, 이 역시 테이블 예약 제안과 관련이 없는 정보입니다. 따라서 제안에 직접 응답하는 A가 올바른 답변입니다.",
  },
  {
    questionNumber: 34,
    questionText: "Would you like me to print another copy?",
    choices: {
      A: "No, this one is fine.",
      B: "The room is on the third floor.",
      C: "I went there last summer.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "다른 사본을 인쇄해 드릴까요?",
      choices: {
        A: "아니요, 이것으로 충분합니다.",
        B: "방은 3층에 있습니다.",
        C: "작년 여름에 그곳에 갔었습니다.",
      },
    },
    explanation:
      "다른 사본 인쇄를 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. A는 '아니요, 이것으로 충분합니다'라고 말하며 추가 인쇄 제안에 대해 명확히 거절하고 있습니다. B는 '방은 3층에 있습니다'라고 말하는데, 이는 방 위치에 대한 정보를 제공하는 것으로 인쇄 제안과 관련이 없습니다. C는 '작년 여름에 그곳에 갔었습니다'라고 말하는데, 이 역시 인쇄 제안과 전혀 관련이 없는 정보입니다. 따라서 제안에 직접 응답하는 A가 올바른 답변입니다.",
  },
  {
    questionNumber: 35,
    questionText: "Should we order now or wait for them?",
    choices: {
      A: "Yes, let's go ahead.",
      B: "I left my keys upstairs.",
      C: "He sent the invoice already.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "지금 주문할까요, 아니면 그들을 기다릴까요?",
      choices: {
        A: "네, 지금 주문합시다.",
        B: "열쇠를 위층에 두고 왔어요.",
        C: "그는 이미 청구서를 보냈습니다.",
      },
    },
    explanation:
      "주문 시점에 대한 질문에는 그 질문에 대한 직접적인 응답이 필요합니다. A는 '네, 지금 주문합시다'라고 말하며 질문에 직접 응답하고 있습니다. B는 '열쇠를 위층에 두고 왔어요'라고 말하는데, 이는 주문 시점과 전혀 관련이 없는 정보입니다. C는 '그는 이미 청구서를 보냈습니다'라고 말하는데, 이 역시 주문 시점에 대한 질문과 관련이 없는 정보입니다. 따라서 질문에 직접 응답하는 A가 올바른 답변입니다.",
  },
  {
    questionNumber: 36,
    questionText: "Do you want me to bring the projector?",
    choices: {
      A: "That would be helpful.",
      B: "I'm heading out for lunch.",
      C: "It starts in thirty minutes.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "프로젝터를 가져다 드릴까요?",
      choices: {
        A: "그러면 도움이 될 것 같습니다.",
        B: "점심 식사하러 나가는 중입니다.",
        C: "30분 후에 시작합니다.",
      },
    },
    explanation:
      "프로젝터를 가져다 주겠다는 제안에는 그 제안에 대한 직접적인 응답이 필요합니다. A는 '그러면 도움이 될 것 같습니다'라고 말하며 프로젝터 제안에 긍정적으로 응답하고 있습니다. B는 '점심 식사하러 나가는 중입니다'라고 말하는데, 이는 화자의 현재 상황을 설명하는 것으로 프로젝터 제안에 대한 직접적인 응답이 아닙니다. C는 '30분 후에 시작합니다'라고 말하는데, 이는 시간에 대한 정보를 제공하는 것으로 프로젝터 제안에 대한 직접적인 응답이 아닙니다. 따라서 제안에 직접 응답하는 A가 올바른 답변입니다.",
  },
  {
    questionNumber: 37,
    questionText: "Can I show you where the meeting room is?",
    choices: {
      A: "No, I already found it.",
      B: "I'm not a member here.",
      C: "The lights are still off.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "회의실이 어디 있는지 알려드릴까요?",
      choices: {
        A: "아니요, 이미 찾았습니다.",
        B: "저는 여기 회원이 아닙니다.",
        C: "아직 불이 꺼져 있습니다.",
      },
    },
    explanation:
      "회의실 위치를 안내해 주겠다는 제안에는 그 제안에 대한 직접적인 응답이 필요합니다. A는 '아니요, 이미 찾았습니다'라고 말하며 안내 제안에 대해 명확히 거절하고 있습니다. B는 '저는 여기 회원이 아닙니다'라고 말하는데, 이는 화자의 상태에 대한 정보를 제공하는 것으로 안내 제안에 대한 직접적인 응답이 아닙니다. C는 '아직 불이 꺼져 있습니다'라고 말하는데, 이는 회의실 상태에 대한 정보를 제공하는 것으로 안내 제안에 대한 직접적인 응답이 아닙니다. 따라서 제안에 직접 응답하는 A가 올바른 답변입니다.",
  },
  {
    questionNumber: 38,
    questionText: "Would you like some help with the setup?",
    choices: {
      A: "Yes, I'd love that.",
      B: "The schedule is printed.",
      C: "I was hired last year.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "설치를 도와드릴까요?",
      choices: {
        A: "네, 그러면 좋겠습니다.",
        B: "일정표가 인쇄되어 있습니다.",
        C: "작년에 고용되었습니다.",
      },
    },
    explanation:
      "설치 도움을 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. A는 '네, 그러면 좋겠습니다'라고 말하며 도움 제안에 긍정적으로 응답하고 있습니다. B는 '일정표가 인쇄되어 있습니다'라고 말하는데, 이는 일정표 상태에 대한 정보를 제공하는 것으로 설치 도움 제안에 대한 직접적인 응답이 아닙니다. C는 '작년에 고용되었습니다'라고 말하는데, 이는 화자의 고용 시점에 대한 정보로 설치 도움 제안과 관련이 없습니다. 따라서 제안에 직접 응답하는 A가 올바른 답변입니다.",
  },
  {
    questionNumber: 39,
    questionText: "Should I take notes during the meeting?",
    choices: {
      A: "Yes, that would be great.",
      B: "The printer is broken.",
      C: "There's coffee in the lounge.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "회의 중에 메모를 해야 할까요?",
      choices: {
        A: "네, 그러면 좋겠습니다.",
        B: "프린터가 고장났습니다.",
        C: "라운지에 커피가 있습니다.",
      },
    },
    explanation:
      "회의 중 메모 작성을 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. A는 '네, 그러면 좋겠습니다'라고 말하며 메모 작성 제안에 긍정적으로 응답하고 있습니다. B는 '프린터가 고장났습니다'라고 말하는데, 이는 프린터 상태에 대한 정보를 제공하는 것으로 메모 작성 제안과 관련이 없습니다. C는 '라운지에 커피가 있습니다'라고 말하는데, 이는 커피 위치에 대한 정보로 메모 작성 제안과 관련이 없습니다. 따라서 제안에 직접 응답하는 A가 올바른 답변입니다.",
  },
  {
    questionNumber: 40,
    questionText: "Shall we move this conversation to the break room?",
    choices: {
      A: "That sounds good.",
      B: "I left my charger at home.",
      C: "It was announced yesterday.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "이 대화를 휴게실로 옮길까요?",
      choices: {
        A: "좋은 생각입니다.",
        B: "충전기를 집에 두고 왔어요.",
        C: "어제 발표되었습니다.",
      },
    },
    explanation:
      "대화 장소 이동을 제안하는 질문에는 그 제안에 대한 직접적인 응답이 필요합니다. A는 '좋은 생각입니다'라고 말하며 장소 이동 제안에 긍정적으로 응답하고 있습니다. B는 '충전기를 집에 두고 왔어요'라고 말하는데, 이는 충전기 위치에 대한 정보를 제공하는 것으로 장소 이동 제안과 관련이 없습니다. C는 '어제 발표되었습니다'라고 말하는데, 이는 어떤 사건의 시점에 대한 정보로 장소 이동 제안과 관련이 없습니다. 따라서 제안에 직접 응답하는 A가 올바른 답변입니다.",
  },
];
